import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as $ from "jquery";
import * as _ from "underscore";
import * as ScrollMagic from 'scrollmagic';
import {on, Options} from "../utils/decorators";


interface props {
    controller: any
}

@Options({
    template: false,
    el: "body",
    ui: {
        image: '.product-image',
        wrapper: '.product-detail-wrapper',
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{

    controller = new ScrollMagic.Controller()
    scene: any;

    constructor() {
        super();
    }

    onRender() {
        // var updateLayout = _.debounce(function(e) {
        //     this.wantsInitImageScrollScene();
        // }.bind(this), 500);

        // window.addEventListener("resize", updateLayout, false);

        this.wantsInitImageScrollScene();

    }

    wantsInitImageScrollScene(){

        if($(window).innerWidth() > 768){
            this.initProductImageScrollScene();
        }
    }

    initProductImageScrollScene() {
        let duration = this.ui.wrapper.height() / 2;

        this.scene = new ScrollMagic.Scene({
                triggerElement: ".product-image",
                duration: duration,
                triggerHook: .25
            })
            .setPin('.product-image')
            .addTo(this.controller);
    }
}
